import { render, staticRenderFns } from "./tabla.vue?vue&type=template&id=09dd97b3&scoped=true&"
import script from "./tabla.vue?vue&type=script&lang=js&"
export * from "./tabla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dd97b3",
  null
  
)

export default component.exports